"use client"

import { useEffect, useState } from "react"
import axios from "axios"
import { Link } from "react-router-dom"
import "../styles/vaquejadas.css"
import { FaCalendarAlt } from "react-icons/fa"

function Vaquejadas() {
  const [eventos, setEventos] = useState([])
  const [temposRestantes, setTemposRestantes] = useState({})
  const [loading, setLoading] = useState(true)

  const prioridadeStatus = {
    aberto: 1,
    "em breve": 2,
    encerrado: 3,
    encerrada: 3,
    finalizado: 3,
    finalizada: 3,
    fechado: 3,
    fechada: 3,
  }

  const ordenarEventosPorStatus = (listaEventos = []) => {
    return [...listaEventos].sort((a, b) => {
      const statusA = String(a.status || "").toLowerCase().trim()
      const statusB = String(b.status || "").toLowerCase().trim()

      const prioridadeA = prioridadeStatus[statusA] || 4
      const prioridadeB = prioridadeStatus[statusB] || 4

      if (prioridadeA !== prioridadeB) {
        return prioridadeA - prioridadeB
      }

      if (statusA === "aberto") {
        return new Date(a.dataFim) - new Date(b.dataFim)
      }

      if (statusA === "em breve") {
        return new Date(a.dataInicio) - new Date(b.dataInicio)
      }

      return new Date(b.dataFim) - new Date(a.dataFim)
    })
  }

  useEffect(() => {
    carregarEventos()
  }, [])

  const carregarEventos = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/events`)
      const eventosVisiveis = response.data.filter((evento) => evento.status !== "ocultado")
      const eventosOrdenados = ordenarEventosPorStatus(eventosVisiveis)
      setEventos(eventosOrdenados)

      const tempos = {}
      eventosOrdenados.forEach((evento) => {
        tempos[evento._id] = calcularTempoRestante(evento)
      })
      setTemposRestantes(tempos)
      setLoading(false)
    } catch (err) {
      console.error("Erro ao buscar eventos", err)
      setLoading(false)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      const novosTempos = {}
      eventos.forEach((evento) => {
        novosTempos[evento._id] = calcularTempoRestante(evento)
      })
      setTemposRestantes(novosTempos)
    }, 1000)

    return () => clearInterval(interval)
  }, [eventos])

  const calcularTempoRestante = (evento) => {
    let targetDate
    if (evento.status === "em breve") {
      targetDate = new Date(evento.dataInicio).getTime()
    } else if (evento.status === "aberto") {
      targetDate = new Date(evento.dataFim).getTime()
    } else {
      return { dias: 0, horas: 0, minutos: 0, segundos: 0, zerado: true }
    }

    const agora = new Date().getTime()
    const diferenca = targetDate - agora

    if (diferenca <= 0) {
      return { dias: 0, horas: 0, minutos: 0, segundos: 0, zerado: true }
    }

    const dias = Math.floor(diferenca / (1000 * 60 * 60 * 24))
    const horas = Math.floor((diferenca % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutos = Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60))
    const segundos = Math.floor((diferenca % (1000 * 60)) / 1000)

    return { dias, horas, minutos, segundos, zerado: false }
  }

  const formatarData = (dataString) => {
    const data = new Date(dataString)
    return data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  return (
    <div className="home-wrapperhg">
      <section className="eventos-sectionhg">
        <div className="section-headerhg">
          <h2>Vaquejadas Disponíveis</h2>
          <p>Confira todos os eventos e garanta sua participação</p>
        </div>

        <div className="vaquejadas-containerhg">
          {loading ? (
            <div className="loading-containerhg">
              <div className="loading-spinnerhg"></div>
              <p>Carregando eventos...</p>
            </div>
          ) : eventos.length > 0 ? (
            <div className="eventos-grid-containerhg">
              {eventos.map((evento) => (
                <div key={evento._id} className="evento-card-vaquejadahg">
                  <div className="evento-image-containerhg">
                    <img
                      src={`https://api.ticketdovaqueiro.com/uploads/${evento.imagem}`}
                      alt={evento.nome}
                      className="cartaz-eventohg"
                    />
                    <div className="evento-statushg">{evento.status}</div>
                  </div>

                  <div className="evento-info-vaquejadahg">
                    <div className="evento-nome-vaquejadahg">
                      <h2>{evento.nome}</h2>
                    </div>

                    {temposRestantes[evento._id] && (
                      <div className="contador-vaquejadahg">
                        <div className="evento-dateshg">
                          <div className="date-itemhg">
                            <FaCalendarAlt className="date-iconhg" />
                            <div>
                              <span>De:</span> {formatarData(evento.dataInicio)}
                            </div>
                          </div>
                          <div className="date-itemhg">
                            <FaCalendarAlt className="date-iconhg" />
                            <div>
                              <span>Até:</span> {formatarData(evento.dataFim)}
                            </div>
                          </div>
                        </div>

                        <h5>
                          {evento.status === "em breve" ? "Início das vendas em:" : "Encerramento das vendas em:"}
                        </h5>
                        <div className="contador-fundo-vaquejadahg">
                          <div className="contador-item-vaquejadahg">
                            <span className="contador-principal-vaquejadahg">
                              {String(temposRestantes[evento._id].dias).padStart(2, "0")}
                            </span>
                            <span className="contador-descricao-vaquejadahg">dias</span>
                          </div>
                          <div className="contador-item-vaquejadahg">
                            <span className="contador-principal-vaquejadahg">
                              {String(temposRestantes[evento._id].horas).padStart(2, "0")}
                            </span>
                            <span className="contador-descricao-vaquejadahg">horas</span>
                          </div>
                          <div className="contador-item-vaquejadahg">
                            <span className="contador-principal-vaquejadahg">
                              {String(temposRestantes[evento._id].minutos).padStart(2, "0")}
                            </span>
                            <span className="contador-descricao-vaquejadahg">min</span>
                          </div>
                          <div className="contador-item-vaquejadahg">
                            <span className="contador-principal-vaquejadahg">
                              {String(temposRestantes[evento._id].segundos).padStart(2, "0")}
                            </span>
                            <span className="contador-descricao-vaquejadahg">seg</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {evento.status === "aberto" && !temposRestantes[evento._id].zerado ? (
                    <Link to={`/evento/${evento._id}`} className="botao-comprar-vaquejadahg">
                      COMPRAR
                    </Link>
                  ) : evento.status === "em breve" ? (
                    <Link to={`/evento/${evento._id}`} className="botao-em-breve-vaquejadahg">
                      EM BREVE
                    </Link>
                  ) : (
                    <div className="botao-encerrado-vaquejadahg">VENDAS ENCERRADAS</div>
                  )}

                </div>
              ))}
            </div>
          ) : (
            <div className="no-eventshg">
              <p>Não há eventos disponíveis no momento.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  )
}

export default Vaquejadas
